import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SelectedCustomerObject } from '../operator-permission-dialog/operator-permission-dialog.component';
import { ToastService } from 'src/app/core/services/toast.service';
import {
  AdminGeneratedService,
  Condition,
  ChangeCustomerPartnerRequest,
  FilterType,
  PartnerAgreementsReq,
  PartnerAndCustomersReq,
  RequestFilter,
  UserPartnerOrCustomerInfo,
  PartnerAgreementsDTO,
  AvaiablePartnerAgreementsReq,
  AvailablePartnerAgreementsDetailDTO,
} from 'src/app/core/services/AdminService/admin-service-generate';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/destroyAdapter/unsubscribe-on-destroy-adapter';

@Component({
  selector: 'app-change-partner-dialog',
  templateUrl: './change-partner-dialog.component.html',
  styleUrls: ['./change-partner-dialog.component.css'],
})
export class ChangePartnerDialogComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  @ViewChild('toast') toast: ElementRef;
  selectedPartner: string = null;
  selectedPartnerAggrement: number = null;
  selectedLeaveTime: string = null;
  partnerListData: UserPartnerOrCustomerInfo[];
  partnerAggrementListData: AvailablePartnerAgreementsDetailDTO[];
  selectedCustomerObject: SelectedCustomerObject;
  moveCounter: boolean = false;
  moveLedger: boolean = false;
  partnerAndCustomerDataReq;
  partnerAgreementDataReq;

  customerId;
  oldPartnerId;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminGenerateService: AdminGeneratedService,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.partnerListData = JSON.parse(localStorage.getItem('partners'));
  }

  getCustomerAndPartnerList(query?) {
    // this.customerDDL.showSpinner();
    this.partnerListData = [];
    this.partnerAndCustomerDataReq = new PartnerAndCustomersReq({
      filter: query,
      filterType: FilterType.Partner,
    });

    this.subs.add(
      this.adminGenerateService.dashboardPartnersAndSubPartnersAll().subscribe(
        (res) => {
          this.partnerListData = res;
          // this.partnerListData = res.map((res) => ({
          //   Identity: res.identityId,
          //   Title: res.title + ' / ' + res.identityId,
          // }));

          // if (initialasePartner) {
          //   this.partnerName = res.filter(
          //     (x) => x.identityId === query
          //   )[0]?.identityId;
          // }
          // this.customerDDL.hideSpinner();
        },
        (err) => {}
      )
    );
  }

  getPartnerAggrementList() {
    this.partnerAgreementDataReq = new AvaiablePartnerAgreementsReq({
      partnerId: this.selectedPartner,
    });

    this.subs.add(
      this.adminGenerateService
        .avaiablePartnerAgreements('1', this.partnerAgreementDataReq)
        .subscribe(
          (res) => {
            this.partnerAggrementListData = res;
          },
          (err) => {}
        )
    );
  }

  changeClick() {
    var changeCustomerPartnerRequest = new ChangeCustomerPartnerRequest({
      customerId: this.customerId,
      newPartnerId: this.selectedPartner,
      moveContour: this.moveCounter,
      oldPartnerId: this.oldPartnerId,
      newPartnerAggrementId: this.selectedPartnerAggrement,
      moveLedger: this.moveLedger,
    });
    this.subs.add(
      this.adminGenerateService
        .changeCustomerPartner(changeCustomerPartnerRequest)
        .subscribe(
          (res) => {
            if (res.isSuccess) {
              this.toastService.showSuccessToast(this.toast.nativeElement, {
                title: 'Partner Değiştir',
                content: 'İşleminiz Başarıyla Tamamlanmıştır',
              });
            } else {
              this.toastService.showErrorToast(this.toast.nativeElement, {
                title: 'Partner Değiştir',
                content: res.resultMessage,
              });
            }
          },
          (err) => {
            const message = JSON.parse(err.response);
            let errorMessage = message.resultMessage;
            this.toastService.showErrorToast(this.toast.nativeElement, {
              title: 'Partner Değiştir',
              content:
                errorMessage != undefined ? errorMessage : message.Message,
            });
          }
        )
    );
    this.dialogRef.close(this.selectedCustomerObject);
  }
}
